module.exports = __webpack_public_path__ + "static/img/davis_pictgrid14_800x779.e77fa75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/davis_pictgrid14_800x779.jpg
// module id = omtc
// module chunks = 0